import { AbstractComponent } from "appworks/components/abstract-component";
import { ComponentFactory } from "appworks/components/factories/component-factory";
import { BannerComponent } from "../banner/banner-component";

export class BannerFactory implements ComponentFactory {
    public build(): AbstractComponent {
        const banner = new BannerComponent();

        banner.setMode("default");
        banner.start();

        return banner;
    }
}
